export default __webpack_public_path__ + "static/media/profile.7504c235.svg";